export const useDisappearableStore = defineStore('disappearables', {
  state: () => ({
    toDisappear: [],
    disappearableKeys: [],
  }),
  getters: {
    shouldDisappear() {
      return (key) => {
        return this.toDisappear.some((itemComponent) => itemComponent.key === key)
      }
    },
  },
  actions: {
    async allDisappeared(toDisappearItemComponents) {
      this.toDisappear = toDisappearItemComponents.filter((itemComponent) => this.disappearableKeys.some((key) => key === itemComponent.key))

      if (this.toDisappear.length > 0) {
        // Sleep till all items have disappeared or the timeout is reached
        await new Promise((resolve) => {
          const stopWatch = watch(
            () => this.toDisappear,
            (toDisappear) => {
              if (toDisappear.length === 0) {
                clearTimeout(timeout)
                stopWatch()
                resolve()
              }
            }
          )
          // Timeout after 1 second if not resolved
          const timeout = setTimeout(() => {
            console.warn('Timeout reached while waiting for items to disappear. Took longer than 1000ms.')
            stopWatch()
            resolve()
          }, 1000)
        })
      }
    },
    markDisappeared(key) {
      this.toDisappear = this.toDisappear.filter((itemComponent) => itemComponent.key !== key)
      this.disappearableKeys = this.disappearableKeys.filter((other) => other !== key)
    },
    addDisappearableKey(key) {
      if (!this.disappearableKeys.some((other) => other === key)) {
        this.disappearableKeys.push(key)
      }
    },
  },
})
